<div class="rests-list" (click)="clickOnItem(item)">
    <span>            
        @if(item.ordered || item.inRefund) {
            <button mat-icon-button color="accent" (click)="$event.stopPropagation();deleteItem(item.code)">
                <mat-icon color="accent">delete</mat-icon>
            </button>
        } 
    </span>
    <span  [ngStyle]="{'background-color': item.displaySalePrice ? 'yellow' : 'none'}">
        <div class="rests-item"> {{item.name}} </div>
        <span *ngIf="!orderId && !refundId" class="air">[{{item.codeExch}}]</span>

        <span class="label">на складе</span>
        <span class="air amount">{{item.displayRest}}</span>
        <span class="label">Цена</span>
<!--        <div>

[
                displayPrice    {{item.displayPrice | currency :'RUB':'symbol':'1.2-2':'ru'}} 
                displayClientPrice    {{item.displayClientPrice | currency :'RUB':'symbol':'1.2-2':'ru'}} 
                displaySalePrice    {{item.displaySalePrice | currency :'RUB':'symbol':'1.2-2':'ru'}} 

]
</div> -->
        <span *ngIf="item.displayClientPrice;else NoPersPrice">

            <span class="air">
                <span class="discounted">
                    {{item.displayPrice | currency :'RUB':'symbol':'1.2-2':'ru'}} 
          
                </span>
                <span class="air currency">
                    {{item.displayClientPrice | currency :'RUB':'symbol':'1.2-2':'ru'}}
           
                </span>
            </span>

        </span>
        <ng-template #NoPersPrice>
            <span class="air currency">
                {{item.displayPrice | currency:'RUB':'symbol':'1.2-2':'ru'}}
            </span> / {{item.measure}}
            <!--
                <i style="background-color: yellow;">{{item.prices | json}}</i>
                <hr>
                <i  style="background-color: yellowgreen;">{{priceTypes | json}}</i>
                -->
        </ng-template>

        <span *ngIf="item.displaySalePrice ">
            <span class="air currency">
                Акция {{item.displaySalePrice | currency :'RUB':'symbol':'1.2-2':'ru'}}
            </span>
        </span>

        <span *ngIf="item.stateId" [ngStyle]="{'background-color':item.stateColor}" class="airmax">{{item.stateName}} </span>


        <!-- span *ngIf="item.promo>0" class="promo">Cкидка<span *ngIf="item.promo>0">
        {{item.promo/(item.price+item.promo)
        | percent:'1.1' }}
      </span></span -->
        <span *ngIf="item.ordered">
            <span class="label"><span class="ordered">в заказе {{item.ordered}}</span>
            </span>
        </span>

        <span *ngIf="item.inRefund">
            <span class="label"><span class="ordered">в возврате {{item.inRefund}}</span>
            </span>
        </span>

    </span>
</div>
